<template>
	<div class="page-layout" v-loading="loading">
		<gc-header headerData="batchDirectiveCheck"></gc-header>
		<div class="run-main">
			<div class="serach">
				<gc-advanced-filter
					v-model="form"
					:fields="filterFields"
					@search="handleFilterSearch"
					@reset="handleFilterReset"
				/>
				<gc-column-setting
					:storageKey="`localcolumn-batch-directive-check-${tenantType}`"
					:columns="columns"
					@update-column="data => (columns = data)"
				></gc-column-setting>
			</div>
			<div class="table-show">
				<gc-table
					:columns="columnList"
					:table-data="tableData"
					:border="true"
					:showPage="true"
					:total="page.total"
					:page-size="page.size"
					:currentPage="page.current"
					@current-page-change="
						currentPage => {
							currentPageChange(currentPage, apiBatchTaskReviewList)
						}
					"
					@size-change="
						size => {
							page.size = size
							currentPageChange(1, apiBatchTaskReviewList)
						}
					"
				></gc-table>
			</div>

			<CheckDialog
				:show.sync="showCheckDialog"
				:detail="detail"
				:status="status"
				@update="getList(1, apiBatchTaskReviewList)"
			/>
		</div>
	</div>
</template>

<script>
import { apiBatchTaskReviewList } from '@/apis/batchDirectiveManage.api.js'
import common from '../mixins/common.js'
import deviceTypeOption from '../mixins/deviceTypeOption.js'
import { isBlank, isObject } from '@/utils/validate.js'
import CheckDialog from './CheckDialog.vue'

export default {
	name: 'batchDirectiveCheck',
	components: { CheckDialog },
	mixins: [common, deviceTypeOption],
	data() {
		return {
			form: {
				deviceTypeId: null,
				reviewStatus: null,
				taskName: '',
				time: null,
			},
			options: {},
			showCheckDialog: false,
			detail: {},
			status: null,
			columns: [
				{ key: 'deviceTypeName', name: '设备类型名称', minWidth: 180, tooltip: true },
				{ key: 'taskName', name: '任务名称', minWidth: 180, tooltip: true },
				{ key: 'taskNo', name: '任务编号', minWidth: 180, tooltip: true },
				{ key: 'createTime', name: '任务提交时间', minWidth: 180 },
				{ key: 'number', name: '影响设备数' },
				{
					key: 'reviewStatus',
					name: '任务审核状态',
					render: (h, row) => {
						const val = row.reviewStatus
						const statusMap = {
							0: { class: 'dot-message', text: '未审核' },
							1: { class: 'dot-success', text: '已审核' },
							2: { class: 'dot-error', text: '审核未通过' },
							3: { class: 'dot-warning', text: '已取消' },
						}
						return h(
							'span',
							{ class: isBlank(val) ? '' : statusMap[val]['class'] },
							isBlank(val) ? '--' : statusMap[val]['text'],
						)
					},
				},
				{ key: 'reviewTime', name: '审核时间', width: 180 },
				{ key: 'reviewStaff', name: '审核人' },
				{ key: 'reviewOpinion', name: '审核意见', tooltip: true },
				{
					key: 'oprate',
					name: '操作',
					width: 250,
					render: (h, row) => {
						//  自定义表格内容展示
						const childList = [
							row.reviewStatus == 0 // 待审核
								? h(
										'el-button',
										{
											props: {
												type: 'text',
												size: 'medium',
											},
											on: {
												click: () => {
													this.handleCheck(row, 0)
												},
											},
										},
										'审核下发',
								  )
								: '',
							row.reviewStatus == 1 // 审核通过
								? h(
										'el-button',
										{
											props: {
												type: 'text',
												size: 'medium',
											},
											on: {
												click: () => {
													this.handleCheck(row, 1)
												},
											},
										},
										'取消审核',
								  )
								: '',
							h(
								'el-button',
								{
									props: {
										type: 'text',
										size: 'medium',
									},
									on: {
										click: () => {
											this.handleCheck(row, -1)
										},
									},
								},
								'查看详情',
							),
						]
						const hasVNode = childList.some(item => isObject(item))
						return h('div', {}, hasVNode ? childList : '/')
					},
					fixed: 'right',
				},
			],
		}
	},
	computed: {
		// 燃气：0，水务：1
		tenantType() {
			return this.$store.getters.userInfo.tenantType || '0'
		},
		searchCondition() {
			return [
				{
					key: 'taskName',
					label: '任务名称',
				},
				{
					key: 'deviceTypeIdList',
					dicKey: 'deviceTypeId',
					label: '设备类型',
					type: 'select',
					filterable: true,
					needAllForSearch: true,
					searchOptionKey: {
						label: 'deviceTypeName',
						value: 'deviceTypeId',
					},
					multiple: true,
				},
				{
					key: 'reviewStatus',
					label: '任务审核状态',
					type: 'select',
					needAllForSearch: true,
					searchOptionKey: {
						label: 'name',
						value: 'defaultValue',
					},
				},
				{
					key: 'time',
					label: '任务提交时间',
					type: 'date',
					width: '350px',
				},
			]
		},
		filterFields() {
			return this.searchCondition.map(item => {
				const field = {
					prop: item.key,
					label: item.label,
					type: item.type || 'input',
					defaultValue: item.defaultValue,
				}
				if (item.width) {
					field.width = item.width
				}
				field.props = {
					searchOption: this.options[item.dicKey || item.key],
					filterable: item.filterable || false,
					needAllForSearch: item.needAllForSearch,
					searchOptionKey: item.searchOptionKey,
					multiple: item.multiple,
				}
				return field
			})
		},
		columnList() {
			return this.columns.filter(o => o.selected)
		},
	},
	watch: {
		'form.time': {
			handler(val) {
				if (!val) {
					this.form.startTime = ''
					this.form.endTime = ''
					return
				}
				const [startTime, endTime] = val
				if (startTime && endTime) {
					this.form.startTime = this.dayjs(startTime).format('YYYY-MM-DD') + ' 00:00:00'
					this.form.endTime = this.dayjs(endTime).format('YYYY-MM-DD') + ' 23:59:59'
				}
			},
		},
	},

	mounted() {
		this.$set(this.options, 'reviewStatus', this.$store.getters.dataList.reviewStatus || [])
		this.getList(1, apiBatchTaskReviewList)
	},

	methods: {
		apiBatchTaskReviewList,
		handleFilterSearch() {
			this.getList(1, apiBatchTaskReviewList)
		},
		handleFilterReset() {
			this.getList(1, apiBatchTaskReviewList)
		},
		handleCheck(row, status) {
			if (status === -1) {
				return this.$router.push({
					path: '/run/direct-detail',
					query: {
						taskNo: row.taskNo,
						commandTaskId: row.commandTaskId,
					},
				})
			}
			if (!row.number) {
				return this.$confirm('无影响设备，本次操作无意义！')
			}
			this.detail = row
			this.status = status
			this.showCheckDialog = true
		},
	},
}
</script>
<style lang="scss" scoped>
@import '../runLayout.scss';
.serach-ops {
	margin-bottom: 8px;
}
</style>
